import register from 'preact-custom-element'
import { useEffect, useRef, useState } from 'preact/hooks'
import { getRecentlyProducts, setRecentlyProductsData } from 'helpers/recently-product'
import { elInViewPort } from 'helpers/dom'
import { fetchData, fetchProductsLinked } from 'helpers/fetch'
import { getProductTitle } from 'libs/shopify'
import PlpCard from 'snippets/plp-card/plp-card'
import CarouselSwiper from 'modules/carousel-swiper/carousel-swiper'
import LoaderSpin from 'snippets/loader-spin/loader-spin'
import throttle from 'lodash.throttle'
import { isWishlistEnabled } from 'helpers/wishlist'

let devtools
if (process.env.NODE_ENV === 'development') {
  devtools = require('preact/devtools')
}

function ProductRecently({ handle, heading }) {
  const options = {
    slidesPerView: 'auto',
    spaceBetween: 16,
    freeMode: {
      enabled: true,
      sticky: true
    },
    grabCursor: true,
    speed: 500,
    breakpoints: {
      1024: {
        slidesPerView: 4,
        spaceBetween: 24
      }
    }
  }

  const elRef = useRef(null)
  const [products, setProducts] = useState([])
  const [isFetching, setIsFetching] = useState(false)

  const recentlyHandles = getRecentlyProducts().filter((i) => i !== handle)

  const fetchProducts = async (handles) => {
    const allFetches = handles.map((handle) => {
      return fetchData(`/products/${handle}?view=ajax`).then((product) => {
        return product
      })
    })
    return Promise.all(allFetches).then((results) => results)
  }

  const init = async (handles) => {
    if (handles.length) {
      setIsFetching(true)
      const products = await fetchProducts(handles)
      const dataProducts = products.filter((product) => product)
      if (dataProducts.length) {
        await fetchProductsLinked(dataProducts)
        setProducts(dataProducts)
        const data = dataProducts.map((item) => {
          return (
            item && {
              sku: item.initVariant.sku || ''
            }
          )
        })
        if (data) {
          setRecentlyProductsData(JSON.stringify(data))
        }
      }
      setIsFetching(false)
    } else {
      setIsFetching(false)
    }
  }

  const handleInit = () => {
    if (elInViewPort(elRef.current)) {
      init(recentlyHandles)
      window.removeEventListener('scroll', onInit)
      if (!isWishlistEnabled()) return

      setTimeout(() => {
        document.dispatchEvent(new CustomEvent('swym:collections-loaded'))
      }, 1000)
    }
  }

  const onInit = throttle(handleInit, 500)

  useEffect(() => {
    if (recentlyHandles.length > 0) {
      window.addEventListener('scroll', onInit)
      if (!isWishlistEnabled()) return

      setTimeout(() => {
        document.dispatchEvent(new CustomEvent('swym:collections-loaded'))
      }, 1000)
    }
  }, [])

  return (
    recentlyHandles.length > 0 && (
      <div className="relative py-8 md:py-[56px]" ref={elRef}>
        {!isFetching ? (
          products.length > 0 && (
            <div className="container flex flex-col overflow-hidden">
              {heading && <h3 className="mb-4 truncate pr-4 text-2xl text-grey-1000 md:mb-6 md:text-3xl">{heading}</h3>}
              <CarouselSwiper
                items={<ProductRecentlyItems products={products} />}
                className="carousel-swiper-product-recently"
                options={options}
                navigation={true}
                scrollbar={false}
              />
            </div>
          )
        ) : (
          <div className="flex py-14">
            <div className="container">
              <LoaderSpin width="8" height="8" />
            </div>
          </div>
        )}
      </div>
    )
  )
}

function ProductRecentlyItems({ products }) {
  return products.map(
    (product) =>
      product && (
        <swiper-slide className="w-[264px] md:w-1/3 lg:w-1/4">
          <PlpCard
            title={getProductTitle(product.title)}
            subtitle={product.metafields.sizes}
            handle={product.handle}
            imageUrl={[product.featuredImage]}
            price={product.price}
            originalPrice={product.compareAtPriceMin}
            tags={product.tags}
            className="flex h-full flex-shrink-0 flex-col"
            linkedColors={product.metafields.linkedProducts.colors}
            currentSize={product.metafields.variantOptions.currentSize}
            sku={product.sku}
            variants={product.variants}
          />
        </swiper-slide>
      )
  )
}

register(ProductRecently, 'product-recently', ['handle', 'heading'])
